//
//
//
//
//
//
//
//
//
export default {
  name: 'TicketManage',
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  created: function created() {
    console.log('created ticketManage ' + this.$route.meta.keepAlive);
  },
  activated: function activated() {
    var _this = this;

    console.log('activated ticketManage ' + this.$route.meta.keepAlive);
    this.isRouterAlive = false;
    this.$nextTick(function () {
      return _this.isRouterAlive = true;
    });
  }
};